import { render, staticRenderFns } from "./Principal2.vue?vue&type=template&id=346d34e2&"
import script from "./Principal2.vue?vue&type=script&lang=js&"
export * from "./Principal2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports